import { gql } from 'graphql-request';
import { graphQLApi } from 'utils/Api';
import { GetOverrideInput, GetOverrideVariables, GetOverrideQueryResponse } from '../types';

const getOverrideQuery = gql`
  query GetOverride($input: GetOverrideInput!) {
    payrollGetOverride(input: $input) {
      code
      success
      message
      override {
        id
        setting_id
        setting_name
        valid_from
        valid_to
        override_value
        map_value {
          values
        }
        is_deleted
        created_by
        created_at
        updated_at
        employee_count
      }
    }
  }
`;

export const getOverride = (input: GetOverrideInput): Promise<GetOverrideQueryResponse> => {
  return graphQLApi<GetOverrideQueryResponse, GetOverrideVariables>({
    query: getOverrideQuery,
    queryVariables: {
      input,
    },
  });
};

